import { IComponentOptions } from "angular";
import { MachinesDecommissionViewController } from "./controller";

export const vsComponentName = "machinesDecommissionView";

export const MachinesDecommissionViewComponentOptions: IComponentOptions = {
  controller: MachinesDecommissionViewController,
  controllerAs: "componentController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    machineConfigurations: "<",
  },
};
